import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { requestDeviationList } from '../actions/deviations';
import List from '../components/list/List';
import IssueListItem from '../components/destination/IssueListItem';
import './Deviations.css';
import { disableSubNavbar, enableSubNavbar, setSubNavbar } from '../actions/navbar';

class Deviations extends React.Component {
  componentDidUpdate() {
    const { setSubNavbar, translate } = this.props;
    setSubNavbar({
      title: [
        translate('navigation.deviations'),
      ],
    });
  }

  componentDidMount() {
    const {
      requestDeviationList, disableSubNavbar, setSubNavbar, translate,
    } = this.props;
    requestDeviationList();
    disableSubNavbar();

    setSubNavbar({
      title: [
        translate('navigation.deviations'),
      ],
    });
  }

  deviationsIssues() {
    const issueMap = {};
    const { deviationList = [] } = this.props;

    const hasDestinationData = deviationList.hasData !== undefined ? deviationList.hasData : false;
    if (!hasDestinationData) {
      return Object.values([]);
    }

    const deviationData = deviationList.data !== undefined ? deviationList.data : [];
    const deviations = deviationData.map((destination) => ({
      ...destination,
      key: destination.id,
      link: `/destination/${destination.id}`,
    }));

    deviations.forEach((destination) => {
      (destination.serviceSites || []).forEach((serviceSite) => {
        (serviceSite.issues || []).forEach((issue) => {
          if (!issue.ack) {
            const issueRow = issueMap[destination.id];
            if (issueRow) {
              issueRow.counter += 1;
            } else {
              issueMap[destination.id] = {
                destinationId: destination.id,
                companyName: destination.companyName,
                customerName: destination.customer.name,
                streetAddress: destination.streetAddress,
                postalCode: destination.postalCode,
                city: destination.city,
                counter: 1,
                key: destination.id,
                link: `/destination/${destination.id}/destination`,
              };
            }
          }
        });
      });
    });

    return Object.values(issueMap);
  }

  render() {
    const { translate } = this.props;
    const issues = this.deviationsIssues();
    return (
      <div className="col-sm-12 deviation-block">
        <div>
          {issues.length > 0 ? (
            <List data={issues} topLine={false} separator={false}>
              <IssueListItem />
            </List>
          ) : translate('new_task.no_data_found') }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { locale, deviations: { deviationList } } = state;
  return {
    translate: getTranslate(locale),
    currentLanguage: getActiveLanguage(locale).code,
    deviationList,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestDeviationList,
  disableSubNavbar,
  enableSubNavbar,
  setSubNavbar,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Deviations);
